/**
 * Standard texts for a hand-raised invoice.
 *
 * Inserted into the form and still editable: the operator usually bills the
 * same thing — Shrooms bought for an amount the player chose — and typing it
 * from scratch each time is how two invoices for the same sale end up worded
 * three different ways.
 */

/** The note printed in the closing block when no Shroom count is given. */
export const CUSTOM_PURCHASE_NOTE =
  'Digital goods supplied immediately on payment. Shrooms are prepaid in-game credit for Terraboma; '
  + 'they are not transferable, and any refund is limited to amounts actually deposited.';

/**
 * Standard item texts ("Insert…" on the generator and the editor). `{n}` = the
 * Shroom amount (en-GB grouping, `___` when none yet), `{cur}` = the invoice
 * currency. IN = deposit (sale to the player), OUT = withdrawal; the
 * custom-amount text is offered for both.
 */
export const STANDARD_TEXTS: { key: string; types: Array<'IN' | 'OUT'>; template: string }[] = [
  { key: 'custom', types: ['IN', 'OUT'], template: '{n} Shrooms — Custom Amount Purchase' },
  { key: 'premium', types: ['IN'], template: '{n} Shrooms — Terraboma Premium Currency' },
  { key: 'topup', types: ['IN'], template: 'Top-up of in-game balance — {n} Shrooms (in-game currency)' },
  { key: 'checkout', types: ['IN'], template: 'Custom Shroom purchase — {n} Shrooms' },
  { key: 'refund', types: ['IN'], template: 'Refund of Shroom purchase — {n} Shrooms' },
  { key: 'payout', types: ['OUT'], template: 'Shroom withdrawal — {n} Shrooms converted to {cur}' },
];

export function fillStandardText(template: string, shrooms: number, currency: string): string {
  return template
    .replace('{n}', shrooms > 0 ? shrooms.toLocaleString('en-GB') : '___')
    .replace('{cur}', currency);
}
